import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["onChange", "name", "defaultValue", "value", "disabled", "children", "className"];
import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { useControlled } from '../utils';
import { RadioContext } from './context';
var RadioGroup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var onChange = props.onChange,
    name = props.name,
    defaultValue = props.defaultValue,
    valueProp = props.value,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    children = props.children,
    className = props.className,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  var _useControlled = useControlled(valueProp, defaultValue),
    value = _useControlled[0],
    setValue = _useControlled[1],
    isControlled = _useControlled[2];
  var handleChange = useCallback(function (nextValue, event) {
    setValue(nextValue);
    if (value !== nextValue) {
      onChange === null || onChange === void 0 ? void 0 : onChange(nextValue, event);
    }
  }, [onChange, setValue, value]);
  var contextValue = useMemo(function () {
    return {
      name: name,
      value: typeof value === 'undefined' ? null : value,
      disabled: disabled,
      onChange: handleChange
    };
  }, [disabled, handleChange, name, value]);
  return /*#__PURE__*/React.createElement(RadioContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement("div", _extends({
    role: "radiogroup",
    className: classNames("ap-radio-group", className)
  }, restProps), children));
});
RadioGroup.displayName = 'RadioGroup';
export default RadioGroup;